import type { IconSvgObject } from './types';

const CornerUpRightIcon: IconSvgObject = [
  ["path", { d: "M18 9.00195H11C7.22876 9.00195 5.34315 9.00195 4.17157 10.1735C3 11.3451 3 13.2307 3 17.002V20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 4.00195C14 4.00195 19 7.6844 19 9.00199C19 10.3196 14 14.002 14 14.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerUpRightIcon;
